import React from 'react';
import { Button as MuiButton, Grid, Button, CircularProgress } from '@mui/material';
import styles from './DeviceForm.module.scss';
import deviceStyles from './GamemasterUserDevices.module.scss';

interface ShowDeviceSettingsProps {
    device: any;
    handleBackClick: () => void;
}

const ShowDeviceSettings: React.FC<ShowDeviceSettingsProps> = ({ device, handleBackClick }) => {
    const getDeviceTypeLabel = (identifier: string) => {
        const typeMap: { [key: string]: string } = {
            'ipad': 'iPad',
            'mobile': 'Mobile',
            'other': 'Other'
        };
        return typeMap[identifier?.toLowerCase()] || identifier || '-';
    };

    if (!device) {
        return <div className={styles.loading}><CircularProgress size={20} /></div>;
    }

    return (
        <div className={deviceStyles.showDeviceSetting}>
            <div className={deviceStyles.formContainer}>
                <Grid container direction="column" spacing={2} pl={2}>
                    <Grid container direction="row" justifyContent="space-between">
                        <Grid>
                            <Button className={deviceStyles.backButton} onClick={handleBackClick}>
                                Back
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid xs={12} container direction="row" justifyContent="flex-start" alignItems="center">
                        <h2 className={deviceStyles.formTitle}>Show Device</h2>
                    </Grid>
                </Grid>

                <div className={styles.formRow}>
                    <div className={styles.formField}>
                        <label className={styles.label}>Device Name</label>
                        <input
                            type="text"
                            value={device.name || '-'}
                            readOnly
                            className={styles.inputReadOnly}
                        />
                    </div>

                    <div className={styles.formField}>
                        <label className={styles.label}>Device Type</label>
                        <input
                            type="text"
                            value={getDeviceTypeLabel(device.identifier)}
                            readOnly
                            className={styles.inputReadOnly}
                        />
                    </div>
                </div>

                <div className={styles.formRow}>
                    <div className={styles.formField}>
                        <label className={styles.label}>Username</label>
                        <input
                            type="text"
                            value={device.username || '-'}
                            readOnly
                            className={styles.inputReadOnly}
                        />
                    </div>

                    <div className={styles.formField}>
                        <label className={styles.label}>Password</label>
                        <input
                            type="text"
                            value={device.password || '-'}
                            readOnly
                            className={styles.inputReadOnly}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShowDeviceSettings;

